// extracted by mini-css-extract-plugin
module.exports = {"title":"BasicTitle_title__3Pyuk","title_ja":"BasicTitle_title_ja__1_cJx","title_en":"BasicTitle_title_en__1jPfM"};